export const permissions = ['PERM_CREATE',]

export const roles = ['ADMIN','USER', 'LAWYER', 'APPLICANT']